import { render, staticRenderFns } from "./ChannelsGeneral.vue?vue&type=template&id=1562918f"
import script from "./ChannelsGeneral.vue?vue&type=script&lang=js"
export * from "./ChannelsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports